import { Environment } from '../enums'

const env = {
  // API_URL: 'http://localhost:8082/api',
  API_URL: 'https://api.walaa.com.sa/api',
  // API_URL: 'http://192.168.100.227:8082/api',
  APP_URL: 'http://localhost:3000',
  G_MAP_API_KEY: 'AIzaSyDlfU5TGXUuDkQ-3lpUJMkt2GZ_XRpW7pc',
}

if (process.env.REACT_APP_ENV === Environment.PRODUCTION) {
  env.API_URL = 'https://api.walaa.com.sa/api'
  env.APP_URL = 'https://app.walaa.com.sa'
}

export default env
